<div class="header">
    <h2>{{ 'instructors.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="instructors-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'instructors.fieldset.personal' | translate }}</h2>
        <div class="profile">
            <app-form-avatar
                [control]="form.controls.mediaImageId"
                [label]="'instructors.form.image' | translate"
                inputId="avatar"
                [accept]="['image/*']"
                testId="instructors-add-avatar"
            />
            <div class="fields">
                <div class="row">
                    <app-form-input
                        [control]="form.controls.firstName"
                        [label]="'instructors.form.firstName' | translate"
                        [placeholder]="'instructors.form.firstName.placeholder' | translate"
                        inputId="firstName"
                        testId="instructors-add-first-name"
                    />
                    <app-form-input
                        [control]="form.controls.lastName"
                        [label]="'instructors.form.lastName' | translate"
                        [placeholder]="'instructors.form.lastName.placeholder' | translate"
                        inputId="lastName"
                        testId="instructors-add-last-name"
                    />
                </div>
            </div>
        </div>
    </div>

    <div class="section">
        <h2>{{ 'instructors.fieldset.credentials' | translate }}</h2>
        <app-form-input
            [control]="form.controls.degree"
            [label]="'instructors.form.degree' | translate"
            [placeholder]="'instructors.form.degree.placeholder' | translate"
            inputId="degree"
            testId="instructors-add-degree"
        />
        <app-form-input
            [control]="form.controls.university"
            [label]="'instructors.form.university' | translate"
            [placeholder]="'instructors.form.university.placeholder' | translate"
            inputId="university"
            testId="instructors-add-university"
        />
    </div>
</form>

<div class="footer">
    <p-button [label]="'instructors.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="instructors-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'instructors.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="instructors-add-submit"
        (onClick)="onSubmit()"
    />
</div>
